// Shared contract-grant checklist used by both the create-user (initial
// grants) and edit-user (current grants) forms in OrgUsersTab. The two
// callers hold differently-named state (selected-on-create vs
// granted-on-edit) and differ in copy, so those are all caller-supplied.
import type { ManagedContract } from '../../types';

interface ContractGrantPickerProps {
  legend: string;
  description: string;
  contracts: Pick<ManagedContract, 'id' | 'title' | 'contractNumber'>[];
  selectedIds: string[];
  onToggle: (contractId: string, checked: boolean) => void;
  emptyMessage: string;
}

export default function ContractGrantPicker({
  legend,
  description,
  contracts,
  selectedIds,
  onToggle,
  emptyMessage,
}: ContractGrantPickerProps) {
  return (
    <div>
      <fieldset>
        <legend className="label">{legend}</legend>
        <p className="text-caption text-slate-500 dark:text-slate-400 mb-2">
          {description}
        </p>
        <div className="max-h-40 overflow-y-auto rounded-md border border-slate-200 dark:border-slate-700 divide-y divide-slate-100 dark:divide-slate-800">
          {contracts.length === 0 && (
            <p className="text-body-sm text-slate-500 dark:text-slate-400 p-2">
              {emptyMessage}
            </p>
          )}
          {contracts.map((c) => {
            const checked = selectedIds.includes(c.id);
            return (
              <label
                key={c.id}
                className="grid grid-cols-[auto_1fr_auto] items-start gap-3 cursor-pointer px-2 py-1.5"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  aria-label={c.title}
                  onChange={(e) => onToggle(c.id, e.target.checked)}
                  className="h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-500 mt-0.5"
                />
                <span className="text-body-sm text-slate-700 dark:text-slate-300 min-w-0 break-words">
                  {c.title}
                </span>
                <span className="font-mono text-caption text-slate-500 dark:text-slate-400 shrink-0 whitespace-nowrap mt-0.5">
                  {c.contractNumber}
                </span>
              </label>
            );
          })}
        </div>
      </fieldset>
    </div>
  );
}
